export default `
  mutation setAiProviderKey($provider: AiProvider!, $apiKey: String!) {
    setAiProviderKey(provider: $provider, apiKey: $apiKey) {
      status
      mask
    }
  }
`
